module.exports = __webpack_public_path__ + "static/media/created-by.337783ae.svg";